module.exports = __webpack_public_path__ + "img/2024-11-15c_3.fa998561.jpg";